import React, {FC, KeyboardEvent, useCallback, useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {Spinner} from 'react-bootstrap'
import NodataYet from '../../../Components/NodataYet'
import {CouponFilter, Coupons} from '../../../../services/cellcast.v2.types'
import Select from 'react-select'
import {useDispatch, useSelector} from 'react-redux'
import {GetAllStaff} from '../MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'
import {getAllUserDetails} from '../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {KTSVG} from '../../../../_metronic/helpers'
import {useLazyGetCouponListQuery} from '../../../../services/cellcast.v2'
import CreateCoupon from './components/CreateNewCoupon'
import WSButton from '../../../../_metronic/helpers/components/WSButton/WSButton'
import {showDiscountType} from '../../../Utils/coupon'
import {ROLES} from '../../../Utils/Constant/roles'
import moment from 'moment'

const CouponPage: FC = () => {
  const dispatch = useDispatch()
  const userDetail = useSelector(getAllUserDetails)

  const [params, setParams] = useState<CouponFilter>({
    staffId: userDetail.role === ROLES.SUPER_ADMIN ? '' : userDetail?._id,
    page: 1,
    limit: 10,
    search: '',
  })

  const [triggerFetch, setTriggerFetch] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [selectedCoupon, setSelectedCoupon] = useState<Coupons | null>(null)

  const [fetch, {isLoading, data, isFetching}] = useLazyGetCouponListQuery()
  const stafflist = useSelector((state: any) => state?.StaffAccount?.staffAccountList)

  useEffect(() => {
    fetch(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    dispatch(
      GetAllStaff({
        page: {
          page: 1,
          size: 30,
          search: '',
        },
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (triggerFetch && triggerFetch === true) {
      doFetch(params)
    }
    setTriggerFetch(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerFetch])

  const doFetch = useCallback(
    (params) => {
      fetch(params)
        .then((res) => {
          if ('data' in res) {
          } else if ('error' in res) {
            toast.error(res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [fetch]
  )

  const staffListOptions = () => {
    const defaultOptions = [
      {
        value: ``,
        label: `All`,
      },
    ]

    const list = stafflist?.items
      ? stafflist?.items?.map((key: any) => ({
          value: `${key?._id}`,
          label: `${key?.name}`,
        }))
      : []
    return [...defaultOptions, ...list]
  }

  const handleSetParams = (field: string, value: string) => {
    setParams((params) => ({
      ...params,
      [field]: value,
    }))
    setTriggerFetch(true)
  }

  const handleSearchEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      setTriggerFetch(true)
    }
  }

  const handleShowModal = (state: boolean, item: Coupons | null) => {
    if (state) {
      setShowModal(true)
      setSelectedCoupon(item)
    } else {
      setShowModal(false)
      setSelectedCoupon(null)
    }
  }

  return (
    <>
      <CreateCoupon
        show={showModal}
        handleClose={() => handleShowModal(false, null)}
        edit={selectedCoupon}
        onFetch={() => setTriggerFetch(true)}
      />
      <div className='mt-8'>
        <div className='card p-8'>
          <div className='card-header border-0 p-0 align-items-center mb-10'>
            <div className='d-flex flex-column w-100'>
              <h3 className='card-title align-items-start  flex-column'>
                <span className='card-label fw-bolder fs-2 mb-1'>Coupons</span>
                <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
              </h3>
              <div className='d-flex justify-content-between align-items-center w-100 mt-2'>
                <div className='col-md-6'>
                  <div className='d-flex gap-4'>
                    <div className='d-flex align-items-start col-md-4 me-2'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen021.svg'
                        className='svg-icon-1 position-absolute ms-6 mt-3'
                      />
                      <input
                        type='text'
                        value={params.search ? params.search : ''}
                        data-kt-user-table-filter='search'
                        className='form-control form-control-solid w-170px ps-14'
                        placeholder='Search by code'
                        onChange={(e: any) =>
                          setParams({...params, search: e.target.value, page: 1})
                        }
                        onKeyDown={handleSearchEnter}
                      />
                    </div>
                    {userDetail.role === 'superAdmin' ? (
                      <Select
                        onChange={(e: any) => handleSetParams('staffId', e.value)}
                        options={staffListOptions()}
                      />
                    ) : null}
                  </div>
                </div>
                <div className='d-flex align-items-center gap-4'>
                  <button
                    type='button'
                    className='btn btn-primary'
                    onClick={() => handleShowModal(true, null)}
                  >
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
          {isLoading ? (
            <div className='row flex-center h-200'>
              <Spinner />
            </div>
          ) : (
            <>
              {data?.data?.items && data?.data?.items.length > 0 ? (
                <div className='card-body p-0 pt-1'>
                  <div className='table-responsive'>
                    <table className='table align-middle gs-0 gy-5 all-message-table'>
                      <thead>
                        <tr className='fw-400 text-muted'>
                          <th className='min-w-140px'>Code</th>
                          <th className='min-w-120px'>Type</th>
                          <th className='min-w-140px'>Coupon Type</th>
                          <th className='min-w-140px'>Value</th>
                          <th className='min-w-140px'>Staff</th>
                          <th className='min-w-140px'>Assigned</th>
                          <th className='min-w-140px'>Expired</th>
                          <th className='min-w-140px'>Commission Rate</th>
                          <th className='min-w-140px'>Status</th>
                          <th className='min-w-140px'>Created</th>
                          <th className='min-w-140px'>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isFetching ? (
                          <tr>
                            <td colSpan={20} className='text-center'>
                              <Spinner />
                            </td>
                          </tr>
                        ) : (
                          <>
                            {data?.data?.items &&
                              data?.data?.items?.map((item, i: number) => (
                                <React.Fragment key={i}>
                                  <tr className='border-dashed border-2 border-bottom'>
                                    <td className='top-align'>
                                      <div className='d-flex gap-2 align-items-center'>
                                        <span>{item?.code || '--'}</span>
                                        <WSButton
                                          onClick={() => {
                                            navigator.clipboard.writeText(item?.code)
                                            toast.success('Copied!')
                                          }}
                                          data-action='copy'
                                          className='btn btn-active-color-primary btn-icon btn-sm btn-outline-light'
                                        >
                                          <span className='svg-icon svg-icon-2'>
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              width='24'
                                              height='24'
                                              viewBox='0 0 24 24'
                                              fill='none'
                                            >
                                              <path
                                                opacity='0.5'
                                                d='M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z'
                                                fill='currentColor'
                                              />
                                              <path
                                                fill-rule='evenodd'
                                                clipRule='evenodd'
                                                d='M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z'
                                                fill='currentColor'
                                              />
                                            </svg>
                                          </span>
                                        </WSButton>
                                      </div>
                                    </td>
                                    <td className='top-align'>{item?.type || '--'}</td>
                                    <td className='top-align'>{showDiscountType(item).title}</td>
                                    <td className='top-align'>{showDiscountType(item).value}</td>
                                    <td className='top-align'>{item?.staffId?.name || '--'}</td>
                                    <td className='top-align'>{item?.customers?.length || '--'}</td>
                                    <td className='top-align'>{item?.expiredDay}</td>
                                    <td className='top-align'>{item?.commisionRate || '--'}%</td>
                                    <td>
                                      <span
                                        className={`${
                                          item?.status
                                            ? 'badge badge-light-success '
                                            : 'badge badge-light-danger'
                                        }`}
                                      >
                                        {item?.status ? 'Active' : 'Inactive'}
                                      </span>
                                    </td>
                                    <td className='top-align'>
                                      {moment(item?.createdAt).format('DD/MMM/YYYY HH:mm')}
                                    </td>
                                    <td className='text-center'>
                                      <span
                                        onClick={() => handleShowModal(true, item)}
                                        className='btn btn-bg-light btn-active-color-primary btn-sm'
                                      >
                                        Edit
                                      </span>
                                    </td>
                                  </tr>
                                </React.Fragment>
                              ))}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <NodataYet message='No Coupon (yet!)' />
              )}
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default CouponPage
